import { call, put, takeLatest, all } from 'redux-saga/effects';
import api from '../../../utils/tt-api';
import Actions, { ActionTypes } from './actions';
import notification from '@tt/components/Notification';
import { CONSTANT_VARIABLES } from '../../../views/common/Constant_Variables/constants';

function* fetchAll({ productParams }) {
  try {
    yield put(Actions.setLoader({ showLoader: true }));
    const { data } = yield call(api.get, {
      route: `Product/GetSearched`,
      params: productParams,
    });
    const allProduct = data;
    yield put(Actions.setAll({ allProduct }));
    yield put(Actions.setLoader({ showLoader: false }));
  } catch (err) {
    yield put(Actions.setLoader({ showLoader: false }));
    notification('error', err, '');
    console.warn(err); // Handle exception
  }
}

function* fetchProductAttributeValues({ productAttributeValuesParams }) {
  try {
    yield put(Actions.setLoader({ showLoader: true }));
    const { data } = yield call(api.get, {
      route: `ProductAttribute/GetSearched`,
      params: productAttributeValuesParams,
    });
    const productAttributeValues = data;
    yield put(Actions.setProductAttributeValues({ productAttributeValues }));
    yield put(Actions.setLoader({ showLoader: false }));
  } catch (err) {
    yield put(Actions.setLoader({ showLoader: false }));
    notification('error', err, '');
    console.warn(err); // Handle exception
  }
}

function* fetchProductsAttributes({ productAttributeValuesParams }) {
  try {
    yield put(Actions.setLoader({ showLoader: true }));
    const { data } = yield call(api.get, {
      route: `ProductAttribute/GetAllProductAttributes`,
      params: productAttributeValuesParams,
    });
    const productsAttributes = data;
    yield put(Actions.setProductsAttributes({ productsAttributes }));
    yield put(Actions.setLoader({ showLoader: false }));
  } catch (err) {
    yield put(Actions.setLoader({ showLoader: false }));
    notification('error', err, '');
    console.warn(err); // Handle exception
  }
}

function* fetchProductAttributeValuesById({ id }) {
  try {
    yield put(Actions.setLoader({ showLoader: true }));
    const { data } = yield call(api.get, {
      route: `ProductAttribute/${id}`,
    });
    const productAttributeValuesById = data;
    yield put(Actions.setProductAttributeValuesById({ productAttributeValuesById }));
    yield put(Actions.setLoader({ showLoader: false }));
  } catch (err) {
    yield put(Actions.setLoader({ showLoader: false }));
    notification('error', err, '');
    console.warn(err); // Handle exception
  }
}

function* addorUpdateProductAttributeValues({
  productAttributeValuesData,
  actionName,
  productAttributeValuesParams,
  onSuccess,
}) {
  try {
    yield put(Actions.setLoader({ showLoader: true }));
    yield call(actionName === 'Update' ? api.put : api.post, {
      route: `ProductAttribute`,
      data: productAttributeValuesData,
    });
    yield put(Actions.fetchProductAttributeValues({ productAttributeValuesParams }));
    notification(
      'success',
      actionName === CONSTANT_VARIABLES.ADD
        ? CONSTANT_VARIABLES.PRODUCT_ATTRIBUTE_VALUES_CREATED
        : CONSTANT_VARIABLES.PRODUCT_ATTRIBUTE_VALUES_UPDATED,
      ''
    );
    if (typeof onSuccess === 'function') {
      yield call(onSuccess);
    }
  } catch (err) {
    yield put(Actions.setLoader({ showLoader: false }));
    notification('error', err.toString(), '');
    console.warn(err); // Handle exception
  }
}

function* deleteProductAttributeValues({ id, productAttributeValuesParams }) {
  try {
    yield put(Actions.setLoader({ showLoader: true }));
    yield call(api.delete, {
      route: `ProductAttribute/${id}`,
    });
    yield put(Actions.fetchProductAttributeValues({ productAttributeValuesParams }));
    notification('success', CONSTANT_VARIABLES.PRODUCT_ATTRIBUTE_VALUES_DELETED, '');
  } catch (err) {
    yield put(Actions.setLoader({ showLoader: false }));
    notification('error', err.toString(), '');
    console.warn(err); // Handle exception
  }
}

function* GetAllAttributeCSVData({ searchText }) {
  try {
    yield put(Actions.setLoader({ showLoader: true }));
    const { data } = yield call(api.get, {
      route: `ProductAttribute/GetAllCSVData?searchText=${searchText}`,
    });
    const productAttributeExportCSVFile = data;
    yield put(Actions.setAttributesDataExport({ productAttributeExportCSVFile }));
    notification('success', CONSTANT_VARIABLES.FILE_DOWNLOADED_SUCCESSFULLY, '');
    yield put(Actions.setLoader({ showLoader: false }));
  } catch (error) {
    yield put(Actions.setLoader({ showLoader: false }));
    notification('error', error, '');
    console.warn(error); // Handle exception
  }
}

function* fetchProductAttributeDataTypes() {
  try {
    yield put(Actions.setLoader({ showLoader: true }));
    const { data } = yield call(api.get, {
      route: `GlobalAttribute/DataTypes`,
    });
    const dataTypes = data;
    yield put(Actions.setProductAttributeDataTypes({ dataTypes }));
    yield put(Actions.setLoader({ showLoader: false }));
  } catch (err) {
    yield put(Actions.setLoader({ showLoader: false }));
    notification('error', err, '');
    console.warn(err); // Handle exception
  }
}

function* fetchAllGlobalAttributes() {
  try {
    yield put(Actions.setLoader({ showLoader: true }));
    const { data } = yield call(api.get, {
      route: `GlobalAttribute`,
    });
    const allGlobalAttributes = data;
    yield put(Actions.setAllGlobalAttributes({ allGlobalAttributes }));
    yield put(Actions.setLoader({ showLoader: false }));
  } catch (err) {
    yield put(Actions.setLoader({ showLoader: false }));
    notification('error', err, '');
    console.warn(err); // Handle exception
  }
}

function* fetchGlobalAttributesById({ id }) {
  try {
    yield put(Actions.setLoader({ showLoader: true }));
    const { data } = yield call(api.get, {
      route: `GlobalAttribute/${id}`,
    });
    const globalAttributesById = data;
    yield put(Actions.setGlobalAttributesById({ globalAttributesById }));
    yield put(Actions.setLoader({ showLoader: false }));
  } catch (err) {
    yield put(Actions.setLoader({ showLoader: false }));
    notification('error', err, '');
    console.warn(err); // Handle exception
  }
}

function* fetchGlobalAttributesByProductId({ id, productAttributeValuesParams }) {
  try {
    yield put(Actions.setLoader({ showLoader: true }));
    const { data } = yield call(api.get, {
      route: `GlobalAttribute/GetByProductId/${id}`,
      params: productAttributeValuesParams,
    });
    const globalAttributesByProduct = data;
    yield put(Actions.setGlobalAttributesByProductId({ globalAttributesByProduct }));
    yield put(Actions.setLoader({ showLoader: false }));
  } catch (err) {
    yield put(Actions.setLoader({ showLoader: false }));
    notification('error', err, '');
    console.warn(err); // Handle exception
  }
}

function* fetchAllProductsData() {
  try {
    const { data } = yield call(api.get, {
      route: `Product`,
    });
    const allProductsData = data;
    yield put(Actions.setAllProductsData({ allProductsData }));
  } catch (err) {
    notification('error', err, '');
    console.warn(err); // Handle exception
  }
}

function* addorUpdateProduct({ productData, actionName, productParams, callback }) {
  try {
    yield put(Actions.setLoader({ showLoader: true }));
    yield call(actionName === 'Update' ? api.put : api.post, {
      route: `Product`,
      data: productData,
    });
    yield put(Actions.fetchAll({ productParams }));
    notification(
      'success',
      actionName === CONSTANT_VARIABLES.ADD ? CONSTANT_VARIABLES.PRODUCT_CREATED : CONSTANT_VARIABLES.PRODUCT_UPDATED,
      ''
    );
    if (callback) callback();
  } catch (err) {
    yield put(Actions.setLoader({ showLoader: false }));
    notification('error', err.toString(), '');
    console.warn(err); // Handle exception
  }
}

function* deleteProduct({ id, productParams }) {
  try {
    yield put(Actions.setLoader({ showLoader: true }));
    yield call(api.delete, {
      route: `Product/${id}`,
    });
    yield put(Actions.fetchAll({ productParams }));
    notification('success', CONSTANT_VARIABLES.PRODUCT_DELETED, '');
  } catch (err) {
    yield put(Actions.setLoader({ showLoader: false }));
    notification('error', err.toString(), '');
    console.warn(err); // Handle exception
  }
}

function* fetchProductById({ productId }) {
  try {
    yield put(Actions.setLoader({ showLoader: true }));
    const { data } = yield call(api.get, {
      route: `Product/GetProductById/${productId}`,
    });
    const productDataById = data;
    yield put(Actions.setLoader({ showLoader: false }));
    yield put(Actions.setProductById({ productDataById }));
  } catch (error) {
    yield put(Actions.setLoader({ showLoader: false }));
    notification('error', error.toString(), '');
    console.warn(error); // Handle exception
  }
}

function* getProductsByFactoryId({ factoryId }) {
  try {
    yield put(Actions.setLoader({ showLoader: true }));
    const { data } = yield call(api.get, {
      route: `Product/getproductsbyfactory/${factoryId}`,
    });
    const factoryProducts = data;
    yield put(Actions.setLoader({ showLoader: false }));
    yield put(Actions.setProductsByFactoryId({ factoryProducts }));
  } catch (error) {
    yield put(Actions.setLoader({ showLoader: false }));
    notification('error', error.toString(), '');
    console.warn(error); // Handle exception
  }
}

function* getProductsByToolId({ toolId }) {
  try {
    yield put(Actions.setLoader({ showLoader: true }));
    const { data } = yield call(api.get, {
      route: `Product/getproductsbytoolid/${toolId}`,
    });
    const toolProducts = data;
    yield put(Actions.setLoader({ showLoader: false }));
    yield put(Actions.setProductsByToolId({ toolProducts }));
  } catch (error) {
    yield put(Actions.setLoader({ showLoader: false }));
    notification('error', error.toString(), '');
    console.warn(error); // Handle exception
  }
}

function* getProductImageValidate({ productData }) {
  try {
    yield put(Actions.setLoader({ showLoader: true }));
    const { data } = yield call(api.get, {
      route: `Product/ValidateProductImage/` + productData.id,
    });
    const imageValidation = data;
    const Productdata = data.toJS();
    yield put(Actions.setLoader({ showLoader: false }));
    yield put(Actions.setProductImageValidate({ imageValidation }));
    if (Productdata.message == CONSTANT_VARIABLES.VALIDATE_PRODUCT_MODEL_SUCCESS) {
      notification('success', CONSTANT_VARIABLES.IMAGE_VALIDATION_SUCCESS);
    } else if (Productdata.message == CONSTANT_VARIABLES.VALIDATE_PRODUCT_MODEL_FAILED) {
      notification('info', CONSTANT_VARIABLES.IMAGE_VALIDATION_INFO);
    } else {
      notification('error', CONSTANT_VARIABLES.INTERNAL_SERVER_ERROR);
    }
  } catch (error) {
    yield put(Actions.setLoader({ showLoader: false }));
    notification('error', error.toString(), '');
    console.warn(error); // Handle exception
  }
}

function* getToolsByMesurementUnit({ measurementUnitId }) {
  try {
    const { data } = yield call(api.get, {
      route: `Tool/gettoolsbymeasurementunit/` + measurementUnitId,
    });
    const tools = data;
    yield put(Actions.setToolsByMeasurementUnit({ tools }));
  } catch (error) {
    notification('error', error, '');
    console.warn(error); // Handle exception
  }
}

function* isProductAssigned({ productId }) {
  try {
    yield put(Actions.setProductAssignedLoader({ productAssignedLoader: true }));
    const { data } = yield call(api.get, {
      route: `Product/IsProductAssinged/` + productId,
    });
    const productAssigned = data;
    yield put(Actions.setProductAssigned({ productAssigned }));
    yield put(Actions.setProductAssignedLoader({ productAssignedLoader: false }));
  } catch (error) {
    console.warn(error); // Handle exception
  }
}
// export complete product data in csv
function* productDataExport({ productExportParams }) {
  try {
    yield put(Actions.productDataExportLoader({ productExportCSVLoader: true }));
    const { data } = yield call(api.get, {
      route: 'Product/GetAllCSVData',
      params: productExportParams,
    });
    const productExportCSVData = data;
    yield put(Actions.setProductDataExport({ productExportCSVData }));
    yield put(Actions.productDataExportLoader({ productExportCSVLoader: false }));
    notification('success', CONSTANT_VARIABLES.FILE_DOWNLOADED_SUCCESSFULLY, '');
  } catch (error) {
    notification('error', error, '');
    console.warn(error); // Handle exception
  }
}
// export product by factory
function* productExport({ productExportParams }) {
  try {
    yield put(Actions.setProductExportLoader({ productExportLoader: true }));
    const { data } = yield call(api.get, {
      route: 'Product/ExportProducts',
      params: productExportParams,
    });
    const productExportData = data;
    yield put(Actions.setProductExportData({ productExportData }));
    yield put(Actions.setProductExportLoader({ PostFileproductExportLoader: false }));
    notification('success', CONSTANT_VARIABLES.FILE_DOWNLOADED_SUCCESSFULLY, '');
  } catch (error) {
    notification('error', error, '');
    console.warn(error); // Handle exception
  }
}

function* importExcelProductAttributeValuesFile({ importFileParams, productAttributeValuesParams }) {
  try {
    yield put(Actions.setImportExcelProductAttributeValuesLoader({ importExcelAttributeFileLoader: true }));
    const { data } = yield call(api.post, {
      route: 'ProductAttribute/importAttributeValuesFile',
      data: importFileParams.file,
    });
    const importProductAttributeValuesFile = data;
    yield put(Actions.setImportExcelProductAttributeValuesFile({ importProductAttributeValuesFile }));
    yield put(Actions.setImportExcelProductAttributeValuesLoader({ importExcelAttributeFileLoader: false }));
    yield put(Actions.fetchAll({ productAttributeValuesParams }));
  } catch (error) {
    notification('error', error, '');
    yield put(Actions.setImportExcelProductAttributeValuesLoader({ importExcelAttributeFileLoader: false }));
    console.warn(error); // Handle exception
  }
}

function* importExcelProductFile({ importFileParams, productParams }) {
  try {
    yield put(Actions.setImportExcelProductFileLoader({ importExcelFileLoader: true }));
    const { data } = yield call(api.post, {
      route: 'Product/postFile/',
      data: importFileParams.file,
    });
    const importProductFile = data;
    yield put(Actions.setImportExcelProductFile({ importProductFile }));
    yield put(Actions.setImportExcelProductFileLoader({ importExcelFileLoader: false }));
    yield put(Actions.fetchAll({ productParams }));
  } catch (error) {
    notification('error', error, '');
    yield put(Actions.setImportExcelProductFileLoader({ importExcelFileLoader: false }));
    console.warn(error); // Handle exception
  }
}

export default function* rootSaga() {
  yield all([
    takeLatest(ActionTypes.FETCH_ALL, fetchAll),
    takeLatest(ActionTypes.FETCH_PRODUCT_ATTRIBUTE_VALUES, fetchProductAttributeValues),
    takeLatest(ActionTypes.FETCH_PRODUCTS_ATTRIBUTES, fetchProductsAttributes),
    takeLatest(ActionTypes.FETCH_PRODUCT_ATTRIBUTE_VALUES_BY_ID, fetchProductAttributeValuesById),
    takeLatest(ActionTypes.FETCH_ALL_GLOBAL_ATTRIBUTES, fetchAllGlobalAttributes),
    takeLatest(ActionTypes.FETCH_GLOBAL_ATTRIBUTES_BY_ID, fetchGlobalAttributesById),
    takeLatest(ActionTypes.FETCH_GLOBAL_ATTRIBUTES_BY_PRODUCT_ID, fetchGlobalAttributesByProductId),
    takeLatest(ActionTypes.FETCH_PRODUCT_ATTRIBUTE_DATA_TYPES, fetchProductAttributeDataTypes),
    takeLatest(ActionTypes.FETCH_ALL_PRODUCTS_DATA, fetchAllProductsData),
    takeLatest(ActionTypes.ADD_OR_UPDATE_PRODUCT, addorUpdateProduct),
    takeLatest(ActionTypes.EXPORT_PRODUCT_DATA, productDataExport),
    takeLatest(ActionTypes.ADD_OR_UPDATE_PRODUCT_ATTRIBUTE_VALUES, addorUpdateProductAttributeValues),
    takeLatest(ActionTypes.DELETE_PRODUCT_ATTRIBUTE_VALUES, deleteProductAttributeValues),
    takeLatest(ActionTypes.DELETE_PRODUCT, deleteProduct),
    takeLatest(ActionTypes.FETCH_TOOLS_BY_MEASUREMENT_UNIT, getToolsByMesurementUnit),
    takeLatest(ActionTypes.GET_PRODUCTS_BY_FACTORY_ID, getProductsByFactoryId),
    takeLatest(ActionTypes.GET_PRODUCTS_BY_TOOL_ID, getProductsByToolId),
    takeLatest(ActionTypes.GET_PRODUCT_IMAGE_VALIDATE, getProductImageValidate),
    takeLatest(ActionTypes.IS_PRODUCT_ASSIGNED, isProductAssigned),
    takeLatest(ActionTypes.PRODUCT_EXPORT, productExport),
    takeLatest(ActionTypes.PRODUCT_IMPORT, importExcelProductFile),
    takeLatest(ActionTypes.FETCH_PRODUCT_BY_ID_DATA, fetchProductById),
    takeLatest(ActionTypes.GET_ALL_CSV_DATA, GetAllAttributeCSVData),
    takeLatest(ActionTypes.PRODUCT_ATTRIBUTE_VALUES_IMPORT, importExcelProductAttributeValuesFile),
  ]);
}
